import { Select } from '@mantine/core';
import { GridApi } from 'ag-grid-community';
import { KIND_OPTIONS_WITHOUT_MANUAL } from 'components/tables/data/kind';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

/**
 * The key of the filter.
 */
export const FILTER_KEY = 'kindFilterValue' as const;

/**
 * Parameters of the RevisionTemplateKindSelectFilter component.
 */
export interface RevisionTemplateKindSelectFilterProps {
  api: GridApi;
  onChange: FilterChangeCallback;
}

/**
 * Filter component for the revision template kind column.
 */
export default function RevisionTemplateKindSelectFilter({ api, onChange }: RevisionTemplateKindSelectFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey: FILTER_KEY, onChange, type: 'contains' });

  return (
    <Select
      searchable
      clearable
      w="100%"
      size="sm"
      placeholder="Akýkoľvek typ"
      data={KIND_OPTIONS_WITHOUT_MANUAL}
      value={value}
      onChange={setValue}
    />
  );
}
